import { createIcon } from "@chakra-ui/react";

export const Resourceful = createIcon({
  displayName: "Resourceful",
  viewBox: "0 0 24 24",
  path: [
    <g clipPath="url(#g2ryp9zoya)">
      <path
        fill="currentColor"
        d="M5.7 3C2.554 3 0 5.527 0 8.64v.594c0 .308.161.594.427.757a.911.911 0 0 0 .878.041l1.714-.85c.382.397.87.687 1.406.835l-.66 9.612C3.675 20.913 4.702 22 6 22c1.298 0 2.325-1.087 2.235-2.371l-.652-9.511a3.081 3.081 0 0 0 2.212-1.18H11.4v.296c0 .494.401.891.9.891s.9-.397.9-.89V3.89A.893.893 0 0 0 12.3 3c-.499 0-.9.397-.9.89v.297H9.795A3.098 3.098 0 0 0 7.357 3H5.7zm5.7 4.156H9.3a.9.9 0 0 0-.806.494 1.27 1.27 0 0 1-1.136.694H5.242c-.48 0-.923-.271-1.137-.694A.9.9 0 0 0 2.9 7.253l-.994.486A3.897 3.897 0 0 1 5.7 4.78h1.657c.48 0 .923.271 1.137.694a.9.9 0 0 0 .806.494h2.1v1.187zM22.2 20.22H18v-1.782a.599.599 0 0 0-.6-.593c-.33 0-.6.267-.6.593v1.782H15v-5.344h7.2v5.344zm-7.931-8.424a2.374 2.374 0 0 0-1.069 1.978v6.446c0 .983.806 1.781 1.8 1.781h7.2c.994 0 1.8-.798 1.8-1.781v-6.446c0-.794-.401-1.537-1.069-1.978l-2.531-1.67V4.781C20.4 3.798 19.594 3 18.6 3s-1.8.798-1.8 1.781v5.344l-2.531 1.67zM18 4.78a.59.59 0 0 1 .176-.42.603.603 0 0 1 .848 0 .59.59 0 0 1 0 .84.603.603 0 0 1-.848 0 .59.59 0 0 1-.176-.42z"
      />
    </g>,
    <defs>
      <clipPath id="g2ryp9zoya">
        <path fill="#fff" transform="translate(0 3)" d="M0 0h24v19H0z" />
      </clipPath>
    </defs>,
  ],
  defaultProps: {
    "aria-label": "A hammer and paintbrush"
  }
});

export default Resourceful;
